var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "news-home" },
    _vm._l(_vm.objData, function (news, index) {
      return _c("div", { key: index, staticClass: "news-div" }, [
        index == 0
          ? _c("a", { attrs: { href: news.url, target: "_blank" } }, [
              _c("div", { staticClass: "news-main" }, [
                _c("div", { staticClass: "news-content" }, [
                  _c("img", {
                    staticClass: "material-img",
                    attrs: {
                      src: news.thumbUrl,
                      height: "120px",
                      width: "280px",
                    },
                  }),
                  _c("div", { staticClass: "news-content-title" }, [
                    _c("span", [_vm._v(_vm._s(news.title))]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        index > 0
          ? _c("a", { attrs: { href: news.url, target: "_blank" } }, [
              _c("div", { staticClass: "news-main-item" }, [
                _c("div", { staticClass: "news-content-item" }, [
                  _c("div", { staticClass: "news-content-item-title" }, [
                    _vm._v(_vm._s(news.title)),
                  ]),
                  _c("div", { staticClass: "news-content-item-img" }, [
                    _c("img", {
                      staticClass: "material-img",
                      attrs: { src: news.thumbUrl, height: "100%" },
                    }),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }